export function servicesSection() {
    let
        speed = 400,
        wrap = $(".services-section"),
        head = wrap.find(".navigation li"),
        images = wrap.find(".services-images"),
        descr = wrap.find(".services-descr");

    images.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: speed,
        arrows: true,
    }).on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        descr.slick("slickGoTo", nextSlide);

        head
            .eq(nextSlide).addClass("current-menu-item")
            .siblings().removeClass("current-menu-item");
    });

    descr.slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: speed,
        arrows: true,
        fade: true,
        swipe: false,
        touchMove: false,
        adaptiveHeight: true
    });

    head.on("click", "a", function (e) {
        e.preventDefault();
        images.slick("slickGoTo", $(this).parent().index());
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/servicesSection.js